(function () {
  'use strict';

  var TIER_STRING = '12:0,24:2,60:5,120:7,480:10';
  var PROPERTY_NAME = 'properties[_pg_bulk_pricing_tiers]';

  function parseTiers(value) {
    return String(value || '')
      .split(',')
      .map(function (entry) {
        var parts = entry.split(':');
        return { min: Number(parts[0]), discount: Number(parts[1]) };
      })
      .filter(function (tier) {
        return Number.isFinite(tier.min) && Number.isFinite(tier.discount);
      })
      .sort(function (a, b) {
        return a.min - b.min;
      });
  }

  function calculateMessage(quantity, tiers) {
    var qty = Math.max(0, Number.parseInt(quantity, 10) || 0);
    var firstTier = tiers[0];

    if (!firstTier) return null;

    if (qty < firstTier.min) {
      var minimumRemaining = firstTier.min - qty;
      return {
        label: 'Bulk pricing starts at ' + firstTier.min,
        message:
          'Add ' +
          minimumRemaining +
          ' more to reach the ' +
          firstTier.min +
          '-piece minimum.',
        progress: Math.min(100, (qty / firstTier.min) * 100),
        complete: false,
      };
    }

    var currentIndex = 0;
    for (var index = 0; index < tiers.length; index += 1) {
      if (qty >= tiers[index].min) currentIndex = index;
    }

    var currentTier = tiers[currentIndex];
    var nextTier = null;
    for (var nextIndex = currentIndex + 1; nextIndex < tiers.length; nextIndex += 1) {
      if (tiers[nextIndex].discount > currentTier.discount) {
        nextTier = tiers[nextIndex];
        break;
      }
    }

    if (!nextTier) {
      return {
        label: 'Best bulk rate unlocked',
        message: "You're saving $" + currentTier.discount + ' per bag.',
        progress: 100,
        complete: true,
      };
    }

    var tierStart = currentTier.min;
    for (var startIndex = currentIndex - 1; startIndex >= 0; startIndex -= 1) {
      if (tiers[startIndex].discount !== currentTier.discount) break;
      tierStart = tiers[startIndex].min;
    }

    var remaining = nextTier.min - qty;
    var additionalSavings = nextTier.discount - currentTier.discount;
    var progressRange = nextTier.min - tierStart;
    var progress = progressRange > 0 ? ((qty - tierStart) / progressRange) * 100 : 100;

    return {
      label: 'Next bulk savings',
      message:
        'Add ' +
        remaining +
        ' more to save $' +
        additionalSavings +
        ' more per bag.',
      progress: Math.max(0, Math.min(100, progress)),
      complete: false,
    };
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function renderNudge(nudge, quantity, tiers) {
    var result = calculateMessage(quantity, tiers);
    if (!nudge || !result) return;

    setText(nudge.querySelector('[data-pg-tier-nudge-label]'), result.label);
    setText(nudge.querySelector('[data-pg-tier-nudge-message]'), result.message);

    var progress = nudge.querySelector('[data-pg-tier-nudge-progress]');
    if (progress) progress.style.width = result.progress.toFixed(1) + '%';

    nudge.classList.toggle('pg-tier-nudge--complete', result.complete);
    nudge.hidden = false;
  }

  function addTierProperty(form) {
    var input = form.querySelector('input[name="' + PROPERTY_NAME + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROPERTY_NAME;
      form.appendChild(input);
    }
    input.value = TIER_STRING;
  }

  function buildCartNudge() {
    var nudge = document.createElement('div');
    nudge.className = 'pg-tier-nudge';
    nudge.setAttribute('data-pg-tier-nudge', '');
    nudge.setAttribute('aria-live', 'polite');
    nudge.setAttribute('aria-atomic', 'true');
    nudge.innerHTML =
      '<span class="pg-tier-nudge__icon" aria-hidden="true">$</span>' +
      '<span class="pg-tier-nudge__content">' +
      '<span class="pg-tier-nudge__label" data-pg-tier-nudge-label></span>' +
      '<strong class="pg-tier-nudge__message" data-pg-tier-nudge-message></strong>' +
      '<span class="pg-tier-nudge__progress" aria-hidden="true">' +
      '<span class="pg-tier-nudge__progress-bar" data-pg-tier-nudge-progress></span>' +
      '</span></span>';
    return nudge;
  }

  function scanProducts() {
    var tiers = parseTiers(TIER_STRING);
    document.querySelectorAll('.product-details').forEach(function (details) {
      if (!details.querySelector('.pg-bulk-pricing-disclosure')) return;

      details.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        var quantityInput = form.querySelector('input[name="quantity"]');
        var nudge = form.querySelector('[data-pg-tier-nudge]');
        if (!quantityInput || !nudge) return;

        addTierProperty(form);
        renderNudge(nudge, quantityInput.value, tiers);
      });
    });
  }

  function scanCart() {
    document.querySelectorAll('[data-pg-bulk-pricing-tiers]').forEach(function (row) {
      var quantityInput = row.querySelector('input[name="updates[]"]');
      var quantityCell = row.querySelector('.cart-items__quantity');
      if (!quantityInput || !quantityCell) return;

      var nudge = quantityCell.querySelector(':scope > [data-pg-tier-nudge]');
      if (!nudge) {
        nudge = buildCartNudge();
        quantityCell.appendChild(nudge);
      }

      var tiers = parseTiers(row.getAttribute('data-pg-bulk-pricing-tiers'));
      renderNudge(nudge, quantityInput.value, tiers);
    });
  }

  function scanAll() {
    scanProducts();
    scanCart();
  }

  var scanPending = false;
  function scheduleScan() {
    if (scanPending) return;
    scanPending = true;
    window.requestAnimationFrame(function () {
      scanPending = false;
      scanAll();
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="quantity"], input[name="updates[]"]')) scheduleScan();
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="quantity"], input[name="updates[]"]')) scheduleScan();
  });
  document.addEventListener('quantity-selector:update', scheduleScan);
  document.addEventListener('shopify:section:load', scheduleScan);

  function start() {
    scanAll();
    if (document.body) {
      new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.PineGoodsBulkTierNudge = {
    calculateMessage: calculateMessage,
    parseTiers: parseTiers,
  };
})();
